import { render, staticRenderFns } from "./ReminderDialog4.vue?vue&type=template&id=2e10c09a&scoped=true"
import script from "./ReminderDialog4.vue?vue&type=script&lang=js"
export * from "./ReminderDialog4.vue?vue&type=script&lang=js"
import style0 from "./ReminderDialog4.vue?vue&type=style&index=0&id=2e10c09a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e10c09a",
  null
  
)

export default component.exports